import { useContext } from 'react';
import ConfigContext from './config-context.js';

var useConfig = (function () {
  return useContext(ConfigContext);
});

export default useConfig;
//# sourceMappingURL=use-config.js.map
